export default __webpack_public_path__ + "static/media/home-slider-57.3c38aada.jpg";